/**
 * Face ca hero-ul de pe mobil să încapă în primul ecran până la butoane.
 *
 * Regula: butoanele „Adaugă în coș” / „Vezi produsul” sunt ultimul element care
 * trebuie văzut fără scroll. Punctele de carusel stau sub ele și rămân
 * intenționat sub fold.
 *
 * CSS-ul singur nu poate garanta asta, pentru că nu știe câte rânduri ocupă un
 * titlu. Aici măsurăm rezultatul real și strângem, în ordinea în care conteacă
 * cel mai puțin: întâi înălțimea imaginii, apoi scara tipografică, iar în
 * ultimă instanță eyebrow-ul.
 *
 * Toate valorile se scriu ca proprietăți custom pe cardul hero, deci desktopul
 * (unde regulile nici nu se aplică) rămâne neatins.
 */
const MOBILE = '(max-width: 989px)';
const SAFETY = 8; // marjă sub butoane, ca să nu atingă exact marginea ecranului

/** Pașii de strângere, de la cel mai puțin vizibil la cel mai vizibil. */
const MEDIA_STEPS = [1, 0.9, 0.8, 0.7, 0.62, 0.55, 0.48];
const TYPE_STEPS = [1, 0.94, 0.88, 0.82, 0.76, 0.7];

function reset(hero) {
  hero.style.removeProperty('--dxd-fit-media');
  hero.style.removeProperty('--dxd-fit-type');
  hero.classList.remove('dxd-hero--no-eyebrow');
}

/** Distanța de la marginea de sus a paginii până la marginea de sus a cardului. */
function offsetTop(el) {
  return el.getBoundingClientRect().top + window.scrollY;
}

/**
 * Cât spațiu rămâne din primul ecran, de la cardul hero în jos.
 *
 * Fără marjă de siguranță aici, intenționat: zona de slide-uri trebuie să se
 * termine exact la fold, ca punctele de carusel de sub ea să rămână ascunse.
 * Marja o păstrăm doar la verificarea butoanelor.
 */
function available(hero) {
  return window.innerHeight - offsetTop(hero);
}

/**
 * Depășirea butoanelor față de marginea de jos a primului ecran, în px.
 *
 * Slide-urile se suprapun în aceeași celulă de grilă, deci înălțimea cardului
 * o dă cel mai înalt dintre ele — măsurăm toate, nu doar pe cel activ, ca
 * schimbarea slide-ului să nu împingă butoanele sub fold.
 */
function overflow(hero) {
  let worst = -Infinity;

  hero.querySelectorAll('.dxd-hero__actions').forEach((actions) => {
    worst = Math.max(worst, offsetTop(actions) + actions.offsetHeight);
  });

  if (worst === -Infinity) return 0;
  return Math.ceil(worst - (window.innerHeight - SAFETY));
}

function apply(hero, media, type, hideEyebrow) {
  hero.style.setProperty('--dxd-fit-media', String(media));
  hero.style.setProperty('--dxd-fit-type', String(type));
  hero.classList.toggle('dxd-hero--no-eyebrow', hideEyebrow);
}

function fit(hero) {
  if (!window.matchMedia(MOBILE).matches) {
    reset(hero);
    hero.style.removeProperty('--dxd-hero-h');
    return;
  }

  reset(hero);

  // Cardul ocupă exact spațiul rămas din primul ecran. Punctele, fiind sub
  // card, cad natural sub fold.
  const space = available(hero);
  if (space > 320) hero.style.setProperty('--dxd-hero-h', `${space}px`);

  if (overflow(hero) <= 0) return;

  // 1. Strângem imaginea în înălțime; lățimea rămâne neatinsă.
  for (const media of MEDIA_STEPS) {
    apply(hero, media, 1, false);
    if (overflow(hero) <= 0) return;
  }

  // 2. Micșorăm tipografia, cu imaginea deja la minimul admis.
  for (const type of TYPE_STEPS) {
    apply(hero, MEDIA_STEPS[MEDIA_STEPS.length - 1], type, false);
    if (overflow(hero) <= 0) return;
  }

  // 3. Ultima soluție: renunțăm la eyebrow.
  apply(hero, MEDIA_STEPS[MEDIA_STEPS.length - 1], TYPE_STEPS[TYPE_STEPS.length - 1], true);
}

function fitAll() {
  document.querySelectorAll('.dxd-hero').forEach(fit);
}

/** Recalculăm după ce fonturile web schimbă metrica textului. */
if (document.fonts?.ready) document.fonts.ready.then(fitAll);

fitAll();
document.addEventListener('DOMContentLoaded', fitAll);
window.addEventListener('load', fitAll);
window.addEventListener('resize', fitAll);
window.addEventListener('orientationchange', () => window.setTimeout(fitAll, 150));

// Schimbarea slide-ului aduce alt titlu, deci alt necesar de spațiu.
document.addEventListener('dxd:hero-slide', fitAll);

export { fitAll };
